module.exports = __webpack_public_path__ + "media/images/icons/outlined/account-book-4459ad2f862afcf3d83220d47a4d8bf2.svg";